import algoliasearch from "algoliasearch";

const client = algoliasearch("8ZC1II4SNL", "e52b62bc209ef4095324735a03d3c4ab");
const pathbooksIndex = client.initIndex("pathbooks");
const authorsIndex = client.initIndex("authors");

export { pathbooksIndex, authorsIndex };
